import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    form: {
      user_id     : '',
      name        : '',
      family      : '',
      email       : '',
      department  : '',
      organization: '',
      position    : '',
      event_form  : '',
    },
  },
  getters: {
    user_id: ({}, getters, rootState) => {
      return rootState.autorisation.user_id;
    },
    get_event_form  : ({event_form}) => event_form,
    name            : ({name}) => name,
    get_family      : ({family}) => family,
    get_email       : ({email}) => email,
    get_department  : ({department}) => department,
    get_organization: ({organization}) => organization,
    get_position    : ({position}) => position,
    form            : ({form}) => form,
  },
  mutations: {

  },
  actions: {
    async register_event({rootGetters}) {
      let current_id = rootGetters['news_main/detail/current_id'];

      try {
        await api.events.register_event(current_id);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
